import _classCallCheck from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import styled, { css } from "styled-components";
import Heading from "../Heading";
import Stack from "../Stack";
import ArrowUpIcon from "../icons/ArrowUp";
import defaultTheme from "../defaultTheme";
import FlightDirectIcon from "../icons/FlightDirect";
import { BASE_URL, SMALLEST_HEIGHT } from "./consts";
import LazyImage from "../LazyImage";
import Text from "../Text";
import randomID from "../utils/randomID";
import KEY_CODE_MAP from "../common/keyMaps";
var overlayCss = css(["position:absolute;top:0;left:0;z-index:1;width:100%;height:100%;border-radius:", ";transition:opacity ", " ease-in-out;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.borderRadiusNormal;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.durationNormal;
});
var StyledOverlay = styled.div.withConfig({
  displayName: "DestinationCard__StyledOverlay",
  componentId: "x4idx5-0"
})(["", ";opacity:1;background:linear-gradient( to bottom,rgba(0,0,0,0) 0%,rgba(0,0,0,0) 50%,rgba(0,0,0,0.13) 65%,rgba(0,0,0,0.3) 75%,rgba(0,0,0,0.8) 100% );"], overlayCss);
StyledOverlay.defaultProps = {
  theme: defaultTheme
};
var StyledOverlayHover = styled.div.withConfig({
  displayName: "DestinationCard__StyledOverlayHover",
  componentId: "x4idx5-1"
})(["", ";opacity:0;background:rgba(0,0,0,0.8);"], overlayCss);
StyledOverlayHover.defaultProps = {
  theme: defaultTheme
};
var StyledDestinationCardContent = styled.div.withConfig({
  displayName: "DestinationCard__StyledDestinationCardContent",
  componentId: "x4idx5-2"
})(["position:relative;z-index:2;display:flex;flex-direction:column;padding:", ";width:100%;transition:bottom ", " ease-in-out;bottom:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.spaceSmall;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.durationFast;
}, function (_ref6) {
  var hiddenContentHeight = _ref6.hiddenContentHeight,
      theme = _ref6.theme;
  return "-".concat(hiddenContentHeight + parseInt(theme.orbit.spaceSmall, 10), "px");
});
StyledDestinationCardContent.defaultProps = {
  theme: defaultTheme
};
var StyledDestinationCardHeader = styled.div.withConfig({
  displayName: "DestinationCard__StyledDestinationCardHeader",
  componentId: "x4idx5-3"
})(["margin-bottom:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.orbit.spaceXSmall;
});
StyledDestinationCardHeader.defaultProps = {
  theme: defaultTheme
};
var Shown = styled.div.withConfig({
  displayName: "DestinationCard__Shown",
  componentId: "x4idx5-4"
})(["transition:all ", " ease-in-out;opacity:0;position:relative;top:\"-50%\";margin-bottom:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.orbit.durationFast;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.orbit.spaceXXSmall;
});
Shown.defaultProps = {
  theme: defaultTheme
};
var ArrowUp = styled(ArrowUpIcon).withConfig({
  displayName: "DestinationCard__ArrowUp",
  componentId: "x4idx5-5"
})(["transform:rotate(90deg);margin-left:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.orbit.spaceXXSmall;
});
ArrowUp.defaultProps = {
  theme: defaultTheme
};
var StyledDestinationCardHiddenContent = styled.div.withConfig({
  displayName: "DestinationCard__StyledDestinationCardHiddenContent",
  componentId: "x4idx5-6"
})(["padding:", " 0 0;border-top:1px solid rgba(255,255,255,0.3);"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.orbit.spaceSmall;
});
StyledDestinationCardHiddenContent.defaultProps = {
  theme: defaultTheme
};
var FlightDirect = styled(FlightDirectIcon).withConfig({
  displayName: "DestinationCard__FlightDirect",
  componentId: "x4idx5-7"
})(["transform:", ";"], function (_ref12) {
  var isReturn = _ref12.isReturn;
  return isReturn && "rotate(180deg)";
});
var StyledDestination = styled.div.withConfig({
  displayName: "DestinationCard__StyledDestination",
  componentId: "x4idx5-8"
})(["position:relative;transition:top ", " ease-in-out;top:16px;"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.orbit.durationFast;
});
StyledDestination.defaultProps = {
  theme: defaultTheme
};
var StyledDestinationCard = styled(function (_ref) {
  var height = _ref.height,
      imageURL = _ref.imageURL,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["height", "imageURL", "theme"]);

  return React.createElement("div", props);
}).withConfig({
  displayName: "DestinationCard__StyledDestinationCard",
  componentId: "x4idx5-9"
})(["width:100%;height:", ";display:flex;align-items:flex-end;position:relative;box-sizing:border-box;border-radius:", ";overflow:hidden;cursor:pointer;&:hover{", "{opacity:0;}", "{top:0;}", "{opacity:1;}", "{bottom:0;}", "{opacity:1;top:0;}}&:focus{outline:none;box-shadow:0 0 1px 1px ", ",0 0 1px 3px rgba(1,118,210,0.6);}"], function (_ref14) {
  var height = _ref14.height;
  return height ? "".concat(height, "px") : "100%";
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.orbit.borderRadiusNormal;
}, StyledOverlay, StyledDestination, StyledOverlayHover, StyledDestinationCardContent, Shown, function (_ref16) {
  var theme = _ref16.theme;
  return theme.orbit.colorTextButtonWhiteBordered;
});
StyledDestinationCard.defaultProps = {
  theme: defaultTheme
};

var SmallHeading = function SmallHeading(_ref17) {
  var children = _ref17.children;
  return React.createElement(Text, {
    type: "white",
    element: "div",
    size: "small",
    weight: "bold"
  }, children);
};

var DestinationCard =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DestinationCard, _React$PureComponent);

  function DestinationCard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DestinationCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DestinationCard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hiddenContentHeight: 0
    });

    _defineProperty(_assertThisInitialized(_this), "hiddenContent", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "cardID", randomID("destinationCardID"));

    _defineProperty(_assertThisInitialized(_this), "setHeight", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          hiddenContent = _assertThisInitialize.hiddenContent;

      if (hiddenContent.current) {
        _this.setState({
          hiddenContentHeight: hiddenContent.current.clientHeight
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (ev) {
      var onClick = _this.props.onClick;

      if (onClick) {
        if (ev.keyCode === KEY_CODE_MAP.ENTER) {
          onClick();
        } else if (ev.keyCode === KEY_CODE_MAP.SPACE) {
          ev.preventDefault();
          onClick();
        }
      }
    });

    return _this;
  }

  _createClass(DestinationCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps !== this.props) {
        this.setHeight();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataTest = _this$props.dataTest,
          departureCity = _this$props.departureCity,
          destinationCity = _this$props.destinationCity,
          destinationCountry = _this$props.destinationCountry,
          price = _this$props.price,
          timeOfStay = _this$props.timeOfStay,
          outbound = _this$props.outbound,
          inbound = _this$props.inbound,
          _this$props$height = _this$props.height,
          height = _this$props$height === void 0 ? 300 : _this$props$height,
          onClick = _this$props.onClick,
          _this$props$tabIndex = _this$props.tabIndex,
          tabIndex = _this$props$tabIndex === void 0 ? "0" : _this$props$tabIndex;
      var hiddenContentHeight = this.state.hiddenContentHeight;
      var image = this.props.image.toLowerCase();
      return React.createElement(StyledDestinationCard, {
        "data-test": dataTest,
        onClick: onClick,
        onKeyDown: this.handleKeyDown,
        height: height >= SMALLEST_HEIGHT ? height : SMALLEST_HEIGHT,
        tabIndex: tabIndex,
        role: "link",
        "aria-labelledby": this.cardID
      }, React.createElement(LazyImage, {
        original: {
          webp: " ".concat(BASE_URL, "/photos/385x320/").concat(image, ".webp"),
          jpg: "".concat(BASE_URL, "/photos/385x320/").concat(image, ".jpg")
        },
        placeholder: {
          webp: " ".concat(BASE_URL, "/photos/30x30/").concat(image, ".webp"),
          jpg: "".concat(BASE_URL, "/photos/30x30/").concat(image, ".jpg")
        } // Add that to images kiwi
        ,
        name: destinationCity
      }), React.createElement(StyledOverlay, null), React.createElement(StyledOverlayHover, null), React.createElement(StyledDestinationCardContent, {
        hiddenContentHeight: hiddenContentHeight
      }, React.createElement(StyledDestinationCardHeader, {
        id: this.cardID
      }, React.createElement(Shown, null, React.createElement(Stack, {
        flex: true,
        align: "center",
        justify: "start",
        spacing: "extraTight"
      }, React.createElement(Heading, {
        type: "title3",
        element: "div",
        inverted: true
      }, departureCity), React.createElement(ArrowUp, {
        customColor: "#fff",
        size: "small"
      }))), React.createElement(StyledDestination, null, React.createElement(Heading, {
        type: "title1",
        element: "div",
        inverted: true
      }, destinationCity)), React.createElement(Shown, null, React.createElement(Heading, {
        type: "title4",
        element: "div",
        inverted: true
      }, destinationCountry))), React.createElement(Stack, {
        flex: true,
        justify: "between",
        spaceAfter: "small",
        align: "end"
      }, React.createElement(Heading, {
        type: "title3",
        element: "div",
        inverted: true
      }, price), timeOfStay && React.createElement(Heading, {
        type: "title4",
        element: "div",
        inverted: true
      }, timeOfStay)), React.createElement(StyledDestinationCardHiddenContent, {
        ref: this.hiddenContent
      }, React.createElement(Stack, {
        direction: "row",
        justify: "between"
      }, React.createElement(SmallHeading, null, outbound.text ? outbound.text : React.createElement(React.Fragment, null, React.createElement(FlightDirect, {
        size: "small"
      }), outbound.date)), React.createElement(SmallHeading, null, outbound.type, "\xA0\u2022\xA0", outbound.duration)), inbound && React.createElement(Stack, {
        direction: "row",
        justify: "between"
      }, React.createElement(SmallHeading, null, React.createElement(FlightDirect, {
        size: "small",
        isReturn: true
      }), inbound.date), React.createElement(SmallHeading, null, inbound.type, "\xA0\u2022\xA0", inbound.duration)))));
    }
  }]);

  return DestinationCard;
}(React.PureComponent);

export default DestinationCard;